import DepartmentService from "../department/DepartmentService";
import MarketingService from "@/modules/marketing/MarketingService";

const department = {
  namespaced: true,
  state: {
    modal: {
      show: false
    },
    departments: {
      loading: false,
      rows: []
    },
    selectedDepartment: null,
    selectedDepartmentImage: null,
    mailchimpInterests: []
  },
  actions: {
    showModal({commit}) {
      commit('showModal');
    },
    hideModal({commit}) {
      commit('hideModal');
    },
    async getDepartments({commit}) {
      commit('changeDepartmentsLoading');
      const res = await DepartmentService.getDepartments({expand: 'children,categories.children,thumbnail_image,specialists,branches'});
      const {success, body} = res;
      if (success) {
        commit('getDepartments', body);
      }
      commit('changeDepartmentsLoading');
      return res;
    },
    selectDepartment({commit}, department) {
      commit('selectDepartment', department);
    },
    async createDepartment({commit}, {formData, onUploadProgress}) {
      const res = await DepartmentService.createDepartment(formData, onUploadProgress, 'children,categories.children,thumbnail_image,specialists');

      const {success, body} = res;
      if (success) {
        commit('createDepartment', body);
        commit('selectDepartment', body);
      }

      return res;
    },
    async updateDepartment({commit}, payload) {
      const res = await DepartmentService.updateDepartment(payload.uuid, payload.formData, 'children,categories.children,image');
      const {success, body} = res;
      if (success) {
        let data = { ...body };
        const resp2 = await DepartmentService.getDepartment(payload.uuid, {expand: 'children,categories.children'})
        data.categories = resp2.body.categories
        commit('updateDepartment',  data);
      }
      return res;
    },
    async removeDepartment({commit, state}, uuid) {
      const res = await DepartmentService.removeDepartment(uuid);

      const {success} = res;
      if (success) {
        commit('removeDepartment', uuid);
        // Select first department
        commit('selectDepartment', state.departments.rows[0]);
      }

      return res;
    },
    async updateSelectedDepartmentImage({commit}, payload) {
      commit('updateSelectedDepartmentImage', payload)
    },
    async getMailchimpInterests({commit}) {
      const res = await MarketingService.getMailchimpInterests();
      if (res.success) {
        commit('updateMailchimpInterests', res.body)
      }
    }
  },
  mutations: {
    showModal: state => state.modal.show = true,
    hideModal: state => state.modal.show = false,
    getDepartments: (state, departments) => {
      state.departments.rows = departments;
      if (!state.selectedDepartment) {
        state.selectedDepartment = departments[0];
      }
    },
    changeDepartmentsLoading: state => state.departments.loading = !state.departments.loading,
    selectDepartment: (state, department) => state.selectedDepartment = department,
    createDepartment: (state, department) => state.departments.rows.unshift(department),
    updateDepartment: (state, department) => {
      const index = state.departments.rows.findIndex(b => b.uuid === department.uuid);
      state.departments.rows[index] = department;

      if (state.selectedDepartment && department.uuid === state.selectedDepartment.uuid) {
        state.selectedDepartment = {...department};
      }
    },
    removeDepartment: (state, uuid) => {
      state.departments.rows = state.departments.rows.filter(b => b.uuid !== uuid);
    },
    updateSelectedDepartmentImage(state, attachment) {
      state.selectedDepartmentImage = attachment;
    },
    updateMailchimpInterests(state, payload) {
      state.mailchimpInterests = [...payload];
    }
  }
};

export default department;
